import { render, staticRenderFns } from "./StudentHealth.vue?vue&type=template&id=db85b840&scoped=true&"
import script from "./StudentHealth.vue?vue&type=script&lang=js&"
export * from "./StudentHealth.vue?vue&type=script&lang=js&"
import style0 from "./StudentHealth.vue?vue&type=style&index=0&id=db85b840&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db85b840",
  null
  
)

export default component.exports